// ================================================================
//  FICHIER DE CONTENU — DU SOURIRE À LA FOURCHETTE
//  ✏️  Modifiez ce fichier pour mettre à jour le site
//  💾  Sauvegardez sur GitHub → le site se met à jour en 2 min
// ================================================================

const contenu = {

  // ── INFORMATIONS GÉNÉRALES ─────────────────────────────────────
  nom:       "Du Sourire à la Fourchette",
  slogan:    "Traiteur à Domicile",
  telephone: "06 63 89 41 03",
  email:     "dusourirealafourchette@gmail.com",
  adresse:   "Solliès-Pont, Var (83)",
  facebook:  "https://www.facebook.com/du.sourire.a.la.fourchette",
  instagram: "https://www.instagram.com/dusourirealafourchette/",
  whatsapp:  "33663894103", // format international sans +

  // ── HERO (grande bannière d'accueil) ──────────────────────────
  hero: {
    titre:      "Vos clients vous cherchent.\nSoyez là où ils regardent.",
    sousTitre:  "Des moments gourmands et conviviaux, préparés avec passion pour sublimer vos événements",
    badge:      "Spécialiste Traiteur à Domicile — Var (83)",
    stats: [
      { val: "+150 événements",  label: "Réalisés" },
      { val: "20+",              label: "Convives max" },
      { val: "100%",             label: "Fait maison" },
      { val: "0€",               label: "Devis gratuit" },
    ],
  },

  // ── À PROPOS ──────────────────────────────────────────────────
  apropos: {
    titre:       "Du Sourire à la Fourchette",
    description: "Passionné par la cuisine et le partage, je mets mon savoir-faire au service de vos événements pour vous offrir des moments gastronomiques inoubliables. Chaque plat est préparé avec soin, des produits de qualité et une attention particulière portée aux détails.",
    valeurs: [
      "Produits frais et de qualité",
      "Cuisine faite maison",
      "Service personnalisé",
      "Respect des traditions culinaires",
    ],
  },

  // ── SERVICES ──────────────────────────────────────────────────
  // Pour modifier un service : changez title ou description
  // Pour en ajouter un : copiez un bloc et changez l'id
  services: [
    { id: 1, title: "Paella",                description: "Paella traditionnelle préparée en direct devant vos invités, pour un moment de partage authentique et convivial.",                                            icon: "utensils" },
    { id: 2, title: "Mechoui & Cochon Grillé", description: "Mechoui et cochon à la broche, grillés à la perfection pour régaler vos invités lors de vos grandes occasions.",                                           icon: "party" },
    { id: 3, title: "Couscous",              description: "Couscous généreux et savoureux, préparé dans la pure tradition pour vos événements familiaux ou professionnels.",                                              icon: "menu" },
    { id: 4, title: "Buffets Chauds & Froids", description: "Une large sélection de plats en buffet, adaptés à tous les goûts et toutes les occasions.",                                                                icon: "glass" },
    { id: 5, title: "Événements sur Mesure", description: "Des plats selon vos désirs et vos envies, pour personnaliser entièrement votre événement.",                                                                   icon: "home" },
    { id: 6, title: "Préparation en Direct", description: "Cuisinez devant vos invités pour créer une ambiance unique et partager un vrai moment de convivialité.",                                                      icon: "cake" },
  ],

  // ── STATS (bandeau chiffres clés) ─────────────────────────────
  stats: [
    { nombre: "150+",  label: "Événements réalisés" },
    { nombre: "5000+", label: "Convives satisfaits"  },
    { nombre: "10+",   label: "Années d'expérience"  },
    { nombre: "100%",  label: "Fait maison"           },
  ],

  // ── FAQ ───────────────────────────────────────────────────────
  faq: [
    {
      question: "Quelle est votre zone d'intervention ?",
      answer:   "J'interviens dans tout le Var (83) : Toulon, La Seyne-sur-Mer, Hyères, Carqueiranne, La Farlède, Solliès-Pont, Bandol, Sanary et alentours. N'hésitez pas à me contacter pour les zones plus éloignées."
    },
    {
      question: "Quel est le nombre minimum de personnes ?",
      answer:   "J'interviens à partir de 20 personnes. Pour les grands événements, il n'y a pas de limite !"
    },
    {
      question: "Combien de temps à l'avance faut-il réserver ?",
      answer:   "Je recommande de réserver au minimum 2 à 3 semaines à l'avance, surtout pour les week-ends et la période estivale. Plus tôt c'est mieux pour garantir votre date !"
    },
    {
      question: "Est-ce que vous cuisinez sur place ?",
      answer:   "Oui ! C'est toute la magie de mes prestations. Je prépare et cuisine en direct devant vos invités. C'est un vrai spectacle en plus d'un repas délicieux."
    },
    {
      question: "Comment obtenir un devis ?",
      answer:   "C'est simple et gratuit ! Remplissez le formulaire de réservation sur le site ou contactez-moi directement par WhatsApp. Je vous réponds sous 24h avec un devis personnalisé."
    },
    {
      question: "Quelles spécialités proposez-vous ?",
      answer:   "Paëlla géante, Méchoui, Cochon à la broche, Couscous, Buffets chauds et froids. Chaque prestation est préparée avec des produits frais et de qualité."
    },
  ],

  // ── AVIS CLIENTS ──────────────────────────────────────────────
  // Pour ajouter un avis reçu par email : copiez un bloc ci-dessous
  avis: [
    {
      name:   "Amy Smith",
      date:   "Février 2026",
      rating: 5,
      text:   "Super buffet fait avec amour, un super traiteur à domicile je recommande",
      event:  "Buffet"
    },
    {
      name:   "Marie L.",
      date:   "Janvier 2026",
      rating: 5,
      text:   "Paëlla exceptionnelle pour notre anniversaire ! Cuisinée en direct devant nos invités, tout le monde a adoré. Professionnel, ponctuel et vraiment passionné.",
      event:  "Anniversaire"
    },
    {
      name:   "Pierre M.",
      date:   "Décembre 2025",
      rating: 5,
      text:   "Méchoui parfait pour notre repas de fin d'année en entreprise. 60 personnes ravies ! Je recommande sans hésitation pour tous vos événements dans le Var.",
      event:  "Repas d'entreprise"
    },
  ],

};

export default contenu;
